import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
// 菜单，侧边栏
import index from './modules';

// 系统
import system from './modules/system';
export default [index].concat(_toConsumableArray(system));